<script setup lang="ts">
import {NuxtLayout, NuxtPage} from '#components';



  import * as Sentry from '@sentry/nuxt';

  class SentryExampleFrontendError extends Error {
    constructor(message: string) {
      super(message);
      this.name = "Nuxt test error";
    }
  }
  
  onMounted(async () => {
    try {
      await Sentry.diagnoseSdkConnectivity();
      getSentryData()
    } catch (error) {
      console.warn('Error connecting to sentry', error)
    }
    Sentry.captureMessage('hello sentry')
    getSentryData()
  });
  
  async function getSentryData() {
    /*
    await Sentry.startSpan(
      {
        name: 'Example Frontend Span',
        op: 'test'
      },
      async () => {
        const res = await $fetch('/api/sentry-example-api', { 
          method: 'GET',
          ignoreResponseError: true 
        }).catch(() => null);
        if (!res) {
          hasSentError.value = true;
        }
      }
    );
    */
    throw new SentryExampleFrontendError("This error is raised on the frontend of the example page.");
  }


const storeWS = useWS();
const config = useRuntimeConfig();
storeWS.connect(config.public.WS);
</script>

<template>
    <Toast position="bottom-right" />
    <NuxtPwaManifest />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
</template>

<style>

@import '@vue-flow/core/dist/style.css';
@import '@vue-flow/core/dist/theme-default.css';
body {
  margin: 0;
}

a {
  text-decoration: none;
  color: unset;
}

ul {
  padding: 0;
  margin: 0;
}

* {  -ms-overflow-style: none;
  scrollbar-width: none;
}

*::-webkit-scrollbar {
  display: none;
  /* Safari and Chrome */
}

li {
  list-style: none;
}

* {
  font-family: "PT Root UI", sans-serif;
}

:root {
  --header-height: 52px;
  --color-primary: #04C377;
  --color-red: #FF0C0C;
  --mobile-footer-height: 52px;
  --p-button-primary-background: #04C377;
  --p-button-primary-border-color: #04C377;
}

.p-button-label {
  font-size: 16px;
  line-height: 19px;
  font-weight: 400;
}

.cards-page{
  padding: 0 20px;
}
.description-parameters{
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 0;
  margin:0;
}

.description-item{
  display: flex;
  justify-content: space-between;
}

.item-name, .item-value{
  color: rgb(0, 0, 0);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0%;
  text-align: left;
  margin-left: 0;
}

.item-value{
  text-align: right;
}

.item-value a{
  color:rgb(47, 128, 237); ;
}

.p-treeselect-overlay{
  /* min-width is set dynnamically by the library, this enforces component to use min-width */
  width:0;
}

.p-treeselect-label{
  color: black;
}

.p-tree-node-label:not(:is(.p-tree-node-selected .p-tree-node-label)){
  color: black;
}

.p-toast-message{
  margin-left: auto;
  max-width: calc(100vw - 40px);
}


@media (width >= 1000px) {
  .page-with-modal{
    padding-right: 425px;
  }
}

@media (width >= 1280px) {
  .page-with-modal{
    padding-right: 415px;
  }
}

@media(width >= 1366px){
  .page-with-modal{
    padding-right: 442px
  }
}

@media(width >= 1600px){
  .page-with-modal{
    padding-right: 395px
  }
}

@media(width >= 1910px){
  .page-with-modal{
    padding-right: 384px
  }
}

@media(width >= 3833px){
  .page-with-modal{
    padding-right: 394px
  }
}

@media (width >= 1000px) {
  .slide-with-open-modal{
    padding-right: 405px;
  }
}

@media (width >= 1280px) {
  .slide-with-open-modal{
    padding-right: 393px;
  }
}

@media(width >= 1366px){
  .slide-with-open-modal{
    padding-right: 422px
  }
}

@media(width >= 1600px){
  .slide-with-open-modal{
    padding-right: 375px
  }
}

@media(width >= 1910px){
  .slide-with-open-modal{
    padding-right: 364px
  }
}

@media(width >= 3833px){
  .slide-with-open-modal{
    padding-right: 374px
  }
}

@media (width >= 1000px) {
  .modal-open{
    padding-right: 405px;
  }
}

@media (width >= 1000px) {
  .modal-open{
    padding-right: 425px;
  }
}

@media (width >= 1280px) {
  .modal-open{
    padding-right: 394px;
  }
}

@media(width >= 1366px){
  .modal-open{
    padding-right: 422px
  }
}

@media(width >= 1600px){
  .modal-open{
    padding-right: 375px
  }
}

@media(width >= 1910px){
  .modal-open{
    padding-right: 364px
  }
}

@media(width >= 3833px){
  .modal-open{
    padding-right: 374px
  }
}
</style>
